import React, { useState } from "react";
import { Button, Tab, Dropdown, Select, Segment } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import {
  ListAcademicCycle,
  AcademicCycleForm,
} from "../../../components/Admin/AcademicCycle";
import { usePermissions } from "../../../hooks";
import "./AcademicCycle.scss";

export function AcademicCycle() {
  const { hasPermission } = usePermissions();
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);
  const [selectedYear, setSelectedYear] = useState(
    new Date().getFullYear().toString(),
  );

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  const canCreate = hasPermission("academicCycle", "create");

  // Generate Year Options
  const currentYear = new Date().getFullYear();
  const yearOptions = [{ key: "all", text: "Selecciona un año", value: null }];
  for (let i = currentYear - 9; i <= currentYear + 1; i++) {
    yearOptions.push({
      key: i,
      text: `${i}`,
      value: `${i}`,
    });
  }

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <ListAcademicCycle
            reload={reload}
            onReload={onReload}
            selectedYear={selectedYear}
          />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <div className="academic-cycle-page">
        <div className="academic-cycle-page__header">
          <div className="academic-cycle-page__filters">
            <Select
              className="edunova-select"
              placeholder="Selecciona un año"
              clearable
              options={yearOptions}
              onChange={(e, { value }) => setSelectedYear(value)}
              value={selectedYear}
            />
          </div>

          {canCreate && (
            <Button
              primary
              className="academic-cycle-page__add"
              onClick={onOpenCloseModal}
            >
              Nuevo Año académico
            </Button>
          )}
        </div>
        <Segment className="academic-cycle-page__list">
          <ListAcademicCycle
            reload={reload}
            onReload={onReload}
            selectedYear={selectedYear}
          />
        </Segment>
      </div>
      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        size="small"
        title="Crear Año académico"
      >
        <AcademicCycleForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </>
  );
}
